import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextAlignRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 4.6875C2.77982 4.6875 2.5 4.96732 2.5 5.3125C2.5 5.65768 2.77982 5.9375 3.125 5.9375H16.875C17.2202 5.9375 17.5 5.65768 17.5 5.3125C17.5 4.96732 17.2202 4.6875 16.875 4.6875H3.125ZM6.875 7.8125C6.52982 7.8125 6.25 8.09232 6.25 8.4375C6.25 8.78268 6.52982 9.0625 6.875 9.0625H16.875C17.2202 9.0625 17.5 8.78268 17.5 8.4375C17.5 8.09232 17.2202 7.8125 16.875 7.8125H6.875ZM2.5 11.5625C2.5 11.2173 2.77982 10.9375 3.125 10.9375H16.875C17.2202 10.9375 17.5 11.2173 17.5 11.5625C17.5 11.9077 17.2202 12.1875 16.875 12.1875H3.125C2.77982 12.1875 2.5 11.9077 2.5 11.5625ZM6.875 14.0625C6.52982 14.0625 6.25 14.3423 6.25 14.6875C6.25 15.0327 6.52982 15.3125 6.875 15.3125H16.875C17.2202 15.3125 17.5 15.0327 17.5 14.6875C17.5 14.3423 17.2202 14.0625 16.875 14.0625H6.875Z",
		fill: "currentColor"
	})
});
export default SvgTextAlignRight;
